function initKlaviyoTrigger() {
  const trigger = document.querySelector(".fs-unlock-trigger");
  if (!trigger) return;

  trigger.addEventListener("click", () => {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "XUDA2E"]);
  });

  trigger.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "XUDA2E"]);
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initKlaviyoTrigger();
});
